export const googleMapUrl = (googleMapParam, lang) => {
  let url = 'https://maps.google.com/maps/api/js?v=3';
  if (typeof (googleMapParam) !== 'undefined') {
    const { googleMapAPIKey: key, googleMapClientID: client } = googleMapParam;
    if (key !== 'null') {
      url += `&key=${key}`;
    } else if (client !== 'null') {
      url += `&client=${client}`;
    }
  }
  url += `&language=${lang}`;
  return url;
};
